import Persistable from "../../../storage/persistable";
import NotImplemented from "../../../exceptions/not-implemented";

export default class GameContext extends Persistable {
    constructor(gameId, ruleSetId, gameConfig) {
        super();
        this.gameId = gameId;
        this.gameConfig = gameConfig;
        this.ruleSetId = ruleSetId;
        this.teamContexts = {};
    }

    getTeamContext() {
        throw new NotImplemented();
    }

    getPlayerContext(teamId, playerId) {
        return this.getTeamContext(teamId).getPlayerContext(playerId);
    }

    apiFormat() {
        return {};
    }

    isGameInitialized() {
        return false;
    }
}
